import { render, staticRenderFns } from "./dangyuanfengcai.vue?vue&type=template&id=788b197a&scoped=true&"
import script from "./dangyuanfengcai.vue?vue&type=script&lang=js&"
export * from "./dangyuanfengcai.vue?vue&type=script&lang=js&"
import style0 from "./dangyuanfengcai.vue?vue&type=style&index=0&id=788b197a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788b197a",
  null
  
)

export default component.exports